$(document).off("click", ".js-add-to-cart").on("click", ".js-add-to-cart", function() {
    const $btn = $(this);
    if ($btn.data('loading')) return; // 防止重复点击
    $btn.data('loading', true);

    const variantId = $btn.data("variant-id");
    if (!variantId) return;

    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) {
        console.error('找不到 cart-drawer 元素');
        return;
    }

    // 获取需要更新的 sections
    const sections = cartDrawer.getSectionsToRender();

    // 只发一次 fetch 请求
    fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: new URLSearchParams({
            id: variantId,
            quantity: 1,
            sections: sections.map(s => s.id),
            sections_url: window.location.pathname
        })
    })
    .then(res => res.json())
    .then(response => {
        // 更新侧拉购物车内容
        cartDrawer.renderContents(response);
        cartDrawer.classList.add('active');
    })
    .catch(err => console.error('加入购物车失败', err))
    .finally(() => {
        $btn.data('loading', false);
    });
});
